import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BrandLockup } from "./BrandMark";

/** Global header for every public (signed-out) page. */
export function SiteHeader({ signedIn }: { signedIn: boolean }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link to="/" className="site-brand" onClick={close}>
          <BrandLockup />
        </Link>

        <button
          className="site-burger"
          aria-expanded={open}
          aria-label="Toggle navigation"
          onClick={() => setOpen((v) => !v)}
        >
          <span aria-hidden="true">{open ? "✕" : "☰"}</span>
        </button>

        <nav className={open ? "site-nav open" : "site-nav"}>
          <NavLink to="/" end onClick={close}>Product</NavLink>
          <NavLink to="/how-it-works" onClick={close}>How it works</NavLink>
          <NavLink to="/pricing" onClick={close}>Pricing</NavLink>
          <NavLink to="/partners" onClick={close}>Partners</NavLink>
          <NavLink to="/security" onClick={close}>Security</NavLink>
          <NavLink to="/about" onClick={close}>About</NavLink>
          <NavLink to="/privacy" onClick={close}>Privacy</NavLink>
          <NavLink to="/terms" onClick={close}>Terms</NavLink>
          <Link
            to={signedIn ? "/dashboard" : "/signin"}
            className="btn-link primary"
            onClick={close}
          >
            {signedIn ? "Open app" : "Sign in"}
          </Link>
        </nav>
      </div>
    </header>
  );
}
